import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Check if we're in development mode (dev server or development/vendor build)
 * Vendor mode is treated as development for feature parity
 */
export function isDevelopmentMode(): boolean {
  return import.meta.env.DEV || 
         import.meta.env.MODE === 'development' || 
         import.meta.env.MODE === 'vendor'
}